
import Vue from 'vue'
import { getRoundDataByAddress, claim, getUserDataByRound, calcFee } from '@/wallet'
import { calcUserReward, sleep, isMobile } from '@/utils'

export default Vue.extend({
  name: 'HomeView',
  async mounted() {
    this.roundContractAddress = this.$route.params.roundAddress
    const data = await getRoundDataByAddress(this.roundContractAddress)
    this.roundStart = new Date(data.roundStart * 1000).toLocaleDateString() + ' ' + new Date(data.roundStart * 1000).toLocaleTimeString()
    this.roundEnd = new Date(data.roundEnd * 1000).toLocaleDateString() + ' ' + new Date(data.roundEnd * 1000).toLocaleTimeString()
    this.totalAmountSide1 = data.side1
    this.totalAmountSide2 = data.side2
    //this.fee = data.fee
    getUserDataByRound(this.roundContractAddress).then(async (data) => {
      if (typeof data == 'undefined') {
        return
      }
      this.userAmountSide1 = Math.round(data.side1 / 1e9)
      this.userAmountSide2 = Math.round(data.side2 / 1e9)
      this.userBetsAddress = data.address.toString()
      this.claimedReward = data.claimedReward
      this.claimDisabled = this.claimedReward
      this.userReward = calcUserReward(this.userAmountSide1, this.userAmountSide2, this.totalAmountSide1, this.totalAmountSide2)
      this.userBox = true      
      this.fee = await calcFee(this.roundContractAddress, data.countSide1, data.countSide2)
      this.fee = Number((this.fee / 1e9).toFixed(2))
    })
  },
  data() {
    return {
      fishInputAmount1: 0,
      fishInputAmount2: 0,
      alert: false,
      alertMessage: '',
      roundStart: '',
      roundEnd: '',
      roundContractAddress: '',
      totalAmountSide1: 0,
      totalAmountSide2: 0,
      userAmountSide1: 0,
      userAmountSide2: 0,
      userReward: 0,
      claimDisabled: false,
      claimedReward: false,
      userBetsAddress: '',
      userBox: false,
      fee: 0,
      isMobile
    }
  },
  methods: {
    async _claim() {
      const response = await claim(this.roundContractAddress)
      if (typeof response !== 'undefined') this.claimedReward = true
    },
    async _copy() {
      if(typeof this.$refs.claimAddr == 'undefined') return
      (this.$refs.claimAddr as HTMLElement).focus()
      document.execCommand('copy')
      await sleep(1000)
      this.$root.$emit('bv::hide::tooltip', 'copyBtnClaim')
    },
  },
  watch: {},
})
